/**
 * Member-app membership-scoped analytics events
 * (`EventTrackingService.trackForMembership`). These affect both members in a
 * partner membership (bills, guidance sessions, goals, etc.). Distinct from
 * backend membership analytics (`BackendMembershipEvent`).
 */
export enum AnalyticsMembershipEvent {
    SIGNUP_FUNNEL_PARTNER_MEMBER_CREATED = 'SignupFunnel_PartnerMemberCreated',
    ALL_TASKS_COMPLETED_FOR_GOAL = 'AllTasksCompletedForGoal',
    MONEY_MAP_WORKFLOW_COMPLETE = 'MoneyMapWorkflowComplete',
    FINANCIAL_PROFILE_COMPLETED = 'FinancialProfileCompleted',
    PRE_MONEY_MAP_ONBOARDING_COMPLETED = 'PreMoneyMap_OnboardingCompleted',
    PRE_DISCO_ONBOARDING_COMPLETED = 'PreDisco_OnboardingCompleted',
    MEMBERSHIP_GUIDE_SWITCHED = 'MembershipGuideSwitched',
    /**
     * One of the events below will be designated as our conversion event for
     * marketing platforms. Coordinate any updates with growth / marketing.
     * See EventTrackingService.ts in the backend app.
     */
    GUIDANCE_SESSION_SCHEDULED_VIA_CALENDLY = 'GuidanceSessionScheduledViaCalendly',
    ONBOARDING_FINANCIAL_GOALS_COMPLETE = 'OnboardingFinancialGoalsComplete',
}
